module.exports = __webpack_public_path__ + "74bea0164da5e663721585de9cd67680.svg";